// <a href="" data-product-id="{{ empi }}" data-url="{{ du }}" data-variant-id="{{ epi }}" class="text-white removeWishlist">Wishlist <i class="fa fa-times-circle" aria-hidden="true"></i></a>

var productCardMarkup = `
  <div class="row prodsss as_product_list lazyload">
  
  {{#products}}
 <div class="products listing mb-5" loading="lazy"> 
    <div class="premium mb-5">

        <figure pb-3><a href="{{ du }}" title="{{ dt }}"><img src="{{ iu }}" title="{{ dt }}" alt="{{ dt }}"></a>
   <button id="swym-remove-productBtn" aria-label="Delete" data-variant-id="{{epi}}" data-product-id="{{empi}}" title="Remove {{ dt }}" class="swym-delete-btn swym-nav swym-nav-1 swym-is-button">
     ⨯
</button>
        </figure>
        <div class="detail">
            
            <h3 class="pt-3"><a href="{{ du }}" title="{{ dt }}">{{ dt }}</a></h3>
            <div class="price price">
                <span class="price-item price-item--sale" data-sale-price="">\₹{{ pr }}</span>
            </div>
             <div class="button_view_product" style="display:block;"><a  href="{{ du }}"  data-url="{{ du }}" class="product_more more">+</a></div>

           
        </div>
    </div>
</div>
  {{/products}}
 </div>`
;

function getVariantInfo(variants){
  try{
    let variantKeys = ((variants && variants != "[]") ? Object.keys(JSON.parse(variants)[0]) : []);
    var variantinfo = "";
    if(variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if(variantinfo == "Default Title") {
        variantinfo = "";
      }
    } else {
      variantinfo = "";
    }
  } catch(err) {
    return variants;
  }
}

function swymCallbackFn(swat) {
   var wishlistContentsContainer = document.getElementById('wishlist-items-container');
   _swat.fetchWrtEventTypeET(function (products) {
     console.log(products);
      var formattedWishlistProducts = products.map(function(p){
        p = SwymUtils.formatProductPrice(p);
        p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
        p.variantinfo = (p.variants ? getVariantInfo(p.variants) : "");
        return p;
      });
     
      var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {products : products});
      if(products.length > 0) {
        wishlistContentsContainer.innerHTML = productCardsMarkup;  
      } else {
         var emptyHtml = '<div class="row"><div class="col-sm-12 text-center"><h5>No Any Wishlist Products.</h5></div></div>';
         wishlistContentsContainer.innerHTML = emptyHtml;
      }
       if(products == 0){
            $("#no_product").text("No Any Wishlist Products.");
            }
      attachClickListeners();
     
  }, window._swat.EventTypes.addToWishList);
}
if(!window.SwymCallbacks) {
 window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymCallbackFn);



function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
  
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Adding..";
  window._swat.replayAddToCart(
     {empi: productId, du : du},
    variantId,
    function() {
      e.target.innerHTML = "Moved to cart..";
      window.location.reload();
    },
    function(e) {
      console.log(e);
    }
  );
}

function onRemoveWishProductClick(e) {
  e.preventDefault();
  var productId = e.target.getAttribute("data-product-id");
 
  var variantId = e.target.getAttribute("data-variant-id");
  var du = e.target.getAttribute("data-url");
  e.target.innerHTML = "Removing..";
  window._swat.removeFromWishList(
  {epi:variantId , empi: productId, du : du},
  function(e) {
      window.location.reload();
    }
  );
}

function attachClickListeners(){

  var addToCartButtons = document.getElementsByClassName("add-to-cart");

  for (let i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener("click", onAddToCartClick, false);
  }
/*
  var removeWishlistProdButtons = document.getElementsByClassName("removeWishlist"); 
  for (let i = 0; i < removeWishlistProdButtons.length; i++) {
    removeWishlistProdButtons[i].addEventListener("click", onRemoveWishProductClick, false);
  }
*/
}
function onRemoveBtnClick(e) {
      e.preventDefault();
      var epi = +e.currentTarget.getAttribute("data-variant-id");
      var empi = +e.currentTarget.getAttribute("data-product-id");
      window._swat.fetch(function(products) {
            products.forEach(function(product) {
                  if (epi && empi && product.epi == epi && product.empi == empi){
                        window._swat.removeFromWishList(product, function() {
                              if (!window.SwymCallbacks) {
                                    window.SwymCallbacks = [];
                              }
                              window.SwymCallbacks.push(swymRenderWishlist);
                        });
                  }
            });
      })
    location.reload();
}

function swymRenderWishlist(swat) {
      // Get wishlist items
      swat.fetch(function(products) {
           
            var wishlistContentsContainer = document.getElementById("wishlist-items-container");
            var formattedWishlistedProducts = products.map(function(p) {
                  p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
                  p.isInCart = _swat.platform.isInDeviceCart(p.epi) || (p.et == _swat.EventTypes.addToCart);
                  p.variantinfo = (p.vi ? getVariantInfo(p.vi) : "");
                  return p;
            });
            var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
                  products: formattedWishlistedProducts
            });
            if(wishlistContentsContainer){
                  wishlistContentsContainer.innerHTML = productCardsMarkup;
                  attachClickListeners();
            } else{
              console.log("Container not found, Wishlist Page element not found");
            }
        
      });
}

function attachClickListeners() {
      var addToCartButtons = document.querySelectorAll("#swym-custom-add-toCartBtn");
      var removeBtns = document.querySelectorAll("#swym-remove-productBtn");
      //   Add to cart Btns
      for (var i = 0; i < addToCartButtons.length; i++) {
            addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
      }
      //   Remove Buttons
      for (var k = 0; k < removeBtns.length; k++) {
            removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
      }


}

if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */